import React, { useState } from 'react';
import arrowDown from '@nsgscholarship/assets/icons/arrow-down.svg';
import email from '@nsgscholarship/assets/icons/email.svg';
import { $t } from '@/modules/i18n';

export default ({ message }) => {
  const [openList, setOpenList] = useState([]);
  // const [openList, setOpenList] = useState(message ? message.list.map((item, index) => index) : []);

  const handleClickFaq = (index) => {
    if(!openList.includes(index)) {
      openList.push(index);
    } else {
      openList.splice(openList.indexOf(index), 1);
    }
    setOpenList([...openList]);
  }

  return (
    <section className="faq-container">
      <div id="faq" style={{position: "relative", top: -160}}></div>
      <div className="faq-title">{$t(message.title)}</div>
      <div className="content-container">
        <div className="faq-list">
          {
            message.list.map((item, index) => {
              return (
                <div key={index} onClick={() => { handleClickFaq(index) }} className="faq-item">
                  <div className="question-container">
                    <div className="left">
                      <div className="num">{`Q${index + 1}.`}</div>
                      <div className="question-answer">
                        <div className="question">
                          {$t(item.question)}
                        </div>
                        {
                          openList.includes(index) ? (
                            <div onClick={e => {e.stopPropagation()}} className="answer-container">
                              <div className="answer" dangerouslySetInnerHTML={{__html: $t(item.answer)}}></div>
                            </div>
                          ) : null
                        }
                      </div>
                    </div>
                    <div className="right">
                      <img src={arrowDown} className={openList.includes(index) ? "arrow-icon rotate" : "arrow-icon"}/>
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
        <div className="contact-us">
          <div className="contact-title">{$t(message.contact.title)}</div>
          <a href="mailto:corporate.affairs.tw@shopee.com" target="_blank" className="contact-info">
            <img className="contact-icon" src={email}/>
            <div className="text">{$t(message.contact.text)}</div>
          </a>
        </div>
      </div>
      
    </section>
  )
}